module.exports = __webpack_public_path__ + "static/media/info-red-icon.a37241f6.svg";